import { Ticket, TicketPercent } from 'lucide-react';
import { useState } from 'react';

import { ClubeCuponsTab } from '@/features/admin/cupons/components/ClubeCuponsTab';
import { DiscussaoCuponsTab } from '@/features/admin/cupons/components/DiscussaoCuponsTab';
import { usePermissoes } from '@/shared/permissoes/usePermissoes';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/shared/ui/tabs';

type Aba = 'clube' | 'discussao';

/**
 * "Cupons" — duas frentes que só compartilham a tela, não o modelo: o cupom
 * do Clube (parceiro, categoria, faixa por ranque — `ClubeCuponsTab`) e o
 * cupom de desconto no pagamento da discussão técnica
 * (docs/cupons-desconto-discussao.md do backend — `DiscussaoCuponsTab`).
 * Permissões (`admin_cupons.*` / `admin_cupons_discussao.*`) continuam
 * separadas; quem só tem uma delas vê a tela sem a aba da outra, sem o
 * seletor de abas aparecer para uma escolha que não existe.
 */
export function CuponsPage() {
  const { pode } = usePermissoes();
  const podeClube = pode('admin_cupons.visualizar');
  const podeDiscussao = pode('admin_cupons_discussao.visualizar');

  const [aba, setAba] = useState<Aba>(podeClube ? 'clube' : 'discussao');

  if (podeClube && !podeDiscussao) return <ClubeCuponsTab />;
  if (podeDiscussao && !podeClube) return <DiscussaoCuponsTab />;

  return (
    <Tabs value={aba} onValueChange={(v) => setAba(v as Aba)}>
      <TabsList>
        <TabsTrigger value="clube">
          <Ticket className="w-4 h-4" />
          Clube
        </TabsTrigger>
        <TabsTrigger value="discussao">
          <TicketPercent className="w-4 h-4" />
          Discussão técnica
        </TabsTrigger>
      </TabsList>

      <TabsContent value="clube">
        <ClubeCuponsTab />
      </TabsContent>

      <TabsContent value="discussao">
        <DiscussaoCuponsTab />
      </TabsContent>
    </Tabs>
  );
}
